<script>
import {getCurrentInstance, onMounted, ref, watch, onBeforeUnmount, computed} from 'vue';
import commonFn from '@/commons/commonFunction';
import MsCheckbox from '../checkbox/MsCheckbox.vue';
import {shortkeyStatusbar} from '@/mixins/common/shortkeyStatusbar';

export default {
  mixins: [shortkeyStatusbar],
  components: {MsCheckbox},
  props: {
    title: String,
    width: {
      type: Number,
      default: 400,
    },
    message: [String, Array],
    type: {
      type: Number,
      default: 0,
    },
    hideClose: {
      type: Boolean,
      default: false,
    },
    textBtn: {
      type: String,
      default: null,
    },
    /**
     * Thêm optionList cho message có dạng chọn
     * tbngoc 22.07.2022
     */
    optionList: {
      type: Array,
      default: null,
    },

    /**
     * Custom text của checkbox
     */
    customLabelCheckbox: {
      type: String,
      default: null,
    },

    /**
     * Custom các button VD: showConfirmValidate(message, title, customButton, width)
     */
    customButton: {
      type: Object,
      default: {Yes: 'Có', No: 'Không', Cancel: 'Hủy'},
    },

    optionDefault: {
      type: Number,
      default: 1,
    },

    fnEventCustom: {
      type: Function,
      default() {
        return;
      },
    },
  },

  setup(props) {
    const {proxy} = getCurrentInstance();

    // Giá trị của checkbox trên form cảnh báo
    const IsShowMessage = ref(true);

    // Biến thể hiện có sự kiện click từ nội dung html truyền vào không
    const isCustomCallBack = ref(false);
    // pntoan 27.12.2023 Bổ sung thêm event khi click vào html content để xử lý trường hợp nhiều thẻ click được
    const callBackEvent = ref(null);

    // Option trả về
    const option = ref(1);

    option.value = props.optionDefault;

    const shortkey = {
      Close: ['esc'], // Đóng
    };

    const defaultShortKey = computed(() => {
      return shortkey;
    });

    const root = ref(null);
    onMounted(() => {
      proxy.$ms.commonFn.shortkeyPushView(root.value);

      // focus button
      commonFn.focusFirstControl(proxy.$refs['msg']);
      // Add sự kiện vào message truyền vào qua v-html, add class "customCallBack" vào nội dung cần click
      // TVDAT 19/10/2022
      proxy.$nextTick(() => {
        const elements = proxy.$refs['msg'].querySelectorAll('.customCallBack');
        Array.from(elements).forEach(el => {
          el.addEventListener('click', event => {
            isCustomCallBack.value = true;
            callBackEvent.value = event;
          });
        });
      });
    });

    onBeforeUnmount(() => {
      proxy.$ms.commonFn.shortkeyPopView(root.value);
    });

    /**
     * Sự kiện click phần message trên MsMessageBox
     */
    const clickOnMessage = (e, closeFn, windowTarget) => {
      // Nếu click vào thẻ có class chứa tag-close-msg-box thì đóng MsMessageBox đi
      if (e?.target?.classList && e.target.classList.contains('tag-close-msg-box') && typeof closeFn == 'function') {
        closeFn(windowTarget, null);
      }
    };

    function escPress(e, close) {
      e.preventDefault();
      close(this, null);
    }

    /**
     * Check có sự kiện bấm vào message
     * TVDAT 19/10/2022
     */
    watch(isCustomCallBack, newVal => {
      if (newVal) {
        proxy.$close(proxy.$refs['msg'], {isClickCustom: newVal, callBackEvent: callBackEvent.value});
      }
    });

    /**
     * Action luôn ở đây ko theo base chung do chỉ dùng esc
     */
    const shortkeyAction = e => {
      if (e.originEvent.cancel) {
        return;
      }
      const me = proxy;
      const shortkey = e.target.getAttribute('shortkey');
      if (shortkey && shortkey.split('|').indexOf(e.srcKey) > -1) {
        if (Array.isArray(e.commandStopNativeEvent) && e.commandStopNativeEvent.some(x => x === e.srcKey)) {
          e.originEvent.preventDefault();
          e.originEvent.stopPropagation();
          e.originEvent.cancel = true;
        }

        // click vào body để unfocus khỏi control hiện tại -> submit giá trị đang nhập
        document.body.click();

        const selector = ['[shortkey-target="', e.srcKey, '"]'].join('');
        const target = root.value.querySelector(selector);

        if (target) {
          if (target.classList.contains('split-button')) {
            const button = target.querySelector('button');
            if (button) {
              button.click();
            }
          } else {
            target.click();
          }
        } else {
          setTimeout(() => {
            // gọi hàm xử lý tương ứng với phím tắt
            me.buttonClick(e.srcKey, e);
          }, 10);
        }
      }
    };

    /**
     * xử lý event custom
     * nhhoang1 01.04.2024
     */
    const eventCustomClick = (closeFn, windowTarget) => {
      closeFn(windowTarget, null);

      if (props.fnEventCustom && typeof props.fnEventCustom == 'function') {
        props.fnEventCustom();
      }
    };

    return {
      escPress,
      IsShowMessage,
      option,
      defaultShortKey,
      root,
      shortkeyAction,
      clickOnMessage,
      eventCustomClick,
    };
  },
};
</script>

<template>
  <!-- Đợi thiết kế chỉnh lại style sau -->
  <div class="msg-box" ref="root">
    <span v-shortkey="defaultShortKey" class="msg-box-shortkey" @shortkey="shortkeyAction" />
    <div ref="msg" class="msg-center" :style="{width: width + 'px'}">
      <div class="msg-title">
        <div>{{ title }}</div>
        <div v-if="type == 5 && !hideClose" class="msg-question icon24 ic-question ic-question-view-bctc" />
        <!-- Click X chỉ đống message popup -->
        <!-- NXHung 12.06.2023 Sửa giá trị truyền vào $close thành true => ẩn messagebox chứ không ẩn form bên ngoài -->
        <div v-if="!hideClose" class="msg-close icon24 close" @click="$close(this, null)" shortkey-target="Close" />
      </div>
      <div v-if="type == $ms.constant.MessageBoxType.confirmIncurredData" class="msg-question icon24 ic-question" />
      <div
        class="msg-message"
        @click="
          e => {
            clickOnMessage(e, $close, this);
          }
        "
      >
        <template v-if="Array.isArray(message)">
          <div v-for="(item, i) in message" :key="i" class="msg-item" v-html="item" />
        </template>

        <div
          v-else-if="!Array.isArray(message) && type != $ms.constant.MessageBoxType.confirmOnlyTextForm"
          class="msg-item"
          v-html="message"
        />

        <div
          v-else-if="!Array.isArray(message) && type == $ms.constant.MessageBoxType.confirmOnlyTextForm"
          class="msg-item"
          v-text="message"
        />
        <!-- confirm không hiện lại popup này lần sau -->
        <div v-if="type == 7 || type == $ms.constant.MessageBoxType.confirmAutoGenerateParallel" class="mt-1">
          <ms-checkbox
            :label="customLabelCheckbox || 'Không hiển thị lần sau'"
            @change="IsShowMessage = !IsShowMessage"
          />
        </div>

        <div v-if="type == 9" class="flex mt-1">
          <ms-radio
            v-for="(item, index) in optionList"
            :key="index"
            v-model="option"
            :label="item.text"
            name="rdnameMessageBox"
            :key-value="item.value"
            class="mb-2"
          />
          <div class="hr-row" />
          <ms-checkbox
            :label="customLabelCheckbox || 'Không hiển thị lần sau'"
            @change="IsShowMessage = !IsShowMessage"
          />
        </div>

        <div v-if="type == 18" class="flex mt-1">
          <ms-radio
            v-for="(item, index) in optionList"
            :key="index"
            v-model="option"
            :label="item.text"
            name="rdnameMessageBox"
            :key-value="item.value"
            style="display: block"
            class="mb-2"
          />
        </div>
      </div>

      <!-- alert: info/warning -->
      <div
        v-if="
          type == $ms.constant.MessageBoxType.confirm_Info_Warning ||
          type == $ms.constant.MessageBoxType.confirmOnlyTextForm
        "
        class="msg-buttons flex-end"
      >
        <button class="msg-btn btn primary" @click="$close(this, true)">
          {{ textBtn || $t('i18nComponent.MessageBox.Accept') }}
        </button>
      </div>
      <!-- confirm yes_no-->
      <div v-else-if="type == $ms.constant.MessageBoxType.confirm_Yes_No" class="msg-buttons flex-row revert-button">
        <button class="msg-btn btn primary" @click="$close(this, true)">
          {{ textBtn || $t('i18nComponent.MessageBox.Yes') }}
        </button>

        <button class="msg-btn btn secondary-outline" @click="$close(this, false)">
          {{ $t('i18nComponent.MessageBox.No') }}
        </button>
        <div class="flex" />
      </div>

      <!-- confirm yes_no-->
      <div
        v-else-if="type == $ms.constant.MessageBoxType.confirm_Info_Cancel"
        class="msg-buttons flex-row revert-button"
      >
        <button class="msg-btn btn primary" @click="$close(this, true)">
          {{ textBtn || $t('i18nComponent.MessageBox.Yes') }}
        </button>

        <button class="msg-btn btn secondary-outline" @click="$close(this, false)">
          {{ $t('i18nComponent.MessageBox.Cancel') }}
        </button>
        <div class="flex" />
      </div>

      <!-- confirm yes_no_cancel-->
      <div
        v-else-if="type == $ms.constant.MessageBoxType.confirm_Yes_No_Cancel"
        class="msg-buttons flex-row revert-button"
      >
        <button class="msg-btn btn primary" @click="$close(this, true)">
          {{ $t('i18nComponent.MessageBox.Yes') }}
        </button>
        <button class="msg-btn btn secondary-outline" @click="$close(this, false)">
          {{ $t('i18nComponent.MessageBox.No') }}
        </button>
        <div class="flex" />
        <button class="msg-btn btn secondary-outline" @click="$close(this, null)">
          {{ $t('i18nComponent.MessageBox.Cancel') }}
        </button>
      </div>

      <!-- confirm delete-->
      <div v-else-if="type == $ms.constant.MessageBoxType.confirm_Delete" class="msg-buttons flex-row revert-button">
        <button class="msg-btn btn primary" @click="$close(this, true)">
          <!-- Sửa cái này theo bug: 20115 -->
          {{ $t('i18nComponent.MessageBox.Yes') }}
        </button>

        <button class="msg-btn btn secondary-outline" @click="$close(this, false)">
          {{ $t('i18nComponent.MessageBox.No') }}
        </button>

        <div class="flex" />
      </div>
      <!-- confirm Đóng -->
      <div v-else-if="type == $ms.constant.MessageBoxType.confirm_Close" class="msg-buttons flex-end">
        <button class="msg-btn btn primary" @click="$close(this, false)">
          {{ $t('i18nComponent.MessageBox.Close') }}
        </button>
      </div>
      <!-- confirm yes_no-->
      <div
        v-else-if="[5, 7, $ms.constant.MessageBoxType.custom_yes_no].includes(type)"
        class="msg-buttons flex-row revert-button"
      >
        <button
          class="msg-btn btn primary"
          @click="
            $close(
              this,
              type == 7
                ? {
                    answer: true,
                    IsShowMessage: IsShowMessage,
                  }
                : true,
            )
          "
        >
          {{ customButton.Yes }}
        </button>
        <button
          class="msg-btn btn secondary-outline"
          @click="
            $close(
              this,
              type == 7
                ? {
                    answer: false,
                    IsShowMessage: IsShowMessage,
                  }
                : false,
            )
          "
        >
          {{ customButton.No }}
        </button>
        <div class="flex" />
      </div>

      <div v-if="type == 6" class="msg-buttons flex-end">
        <button class="msg-btn btn primary" @click="$close(this, true)">
          {{ textBtn }}
        </button>
      </div>

      <div v-else-if="type == 8" class="msg-buttons flex-row revert-button">
        <button class="msg-btn btn primary" @click="$close(this, true)">Xem phát sinh</button>
        <button class="msg-btn btn secondary-outline" @click="$close(this, false)">
          {{ $t('i18nComponent.MessageBox.Close') }}
        </button>
        <div class="flex" />
      </div>

      <div v-else-if="type == 9" class="msg-buttons flex-row revert-button">
        <button
          class="msg-btn btn primary"
          @click="
            $close(this, {
              answer: true,
              IsShowMessage: IsShowMessage,
              option,
            })
          "
        >
          {{ $t('i18nComponent.MessageBox.Yes') }}
        </button>
        <button
          class="msg-btn btn secondary-outline"
          @click="
            $close(this, {
              answer: false,
              IsShowMessage: IsShowMessage,
              option,
            })
          "
        >
          {{ $t('i18nComponent.MessageBox.No') }}
        </button>
        <div class="flex" />
      </div>

      <div v-else-if="type == 18" class="msg-buttons flex-row revert-button">
        <button
          class="msg-btn btn primary"
          @click="
            $close(this, {
              answer: true,
              IsShowMessage: IsShowMessage,
              option,
            })
          "
        >
          {{ $t('i18nComponent.MessageBox.Yes') }}
        </button>
        <button
          class="msg-btn btn secondary-outline"
          @click="
            $close(this, {
              answer: false,
              IsShowMessage: IsShowMessage,
              option,
            })
          "
        >
          {{ $t('i18nComponent.MessageBox.No') }}
        </button>
        <div class="flex" />
      </div>

      <!-- Cảnh báo khi check chi tiết theo danh mục tài khoản -->
      <div v-else-if="type == 11" class="msg-buttons flex-row revert-button">
        <button class="msg-btn btn primary" @click="$close(this, true)">
          {{ $t('i18nComponent.MessageBox.Yes') }}
        </button>
        <button class="msg-btn btn secondary-outline" @click="$close(this, false)">
          {{ $t('i18nComponent.MessageBox.No') }}
        </button>
        <div class="flex" />
      </div>

      <!-- Xác nhận sinh hạch toán đồng thời-->
      <div
        v-else-if="type == $ms.constant.MessageBoxType.confirmAutoGenerateParallel"
        class="msg-buttons flex-row revert-button"
      >
        <button class="msg-btn btn primary" @click="$close(this, {answer: true, IsShowMessage: IsShowMessage})">
          {{ customButton.Yes }}
        </button>
        <button
          class="msg-btn btn secondary-outline"
          @click="$close(this, {answer: false, IsShowMessage: IsShowMessage})"
        >
          {{ customButton.No }}
        </button>
        <div class="flex" />
        <button class="msg-btn btn secondary-outline" @click="$close(this, null)">
          {{ customButton.Cancel }}
        </button>
      </div>
      <div
        v-else-if="type == $ms.constant.MessageBoxType.confirmIncurredData"
        class="msg-buttons flex-row revert-button"
      >
        <button class="msg-btn btn primary" @click="$close(this, true)">
          {{ $t('i18nComponent.MessageBox.View') }}
        </button>
        <button class="msg-btn btn secondary-outline" @click="$close(this, false)">
          {{ $t('i18nComponent.MessageBox.No') }}
        </button>
        <div class="flex" />
      </div>
      <div
        v-else-if="type == $ms.constant.MessageBoxType.confirmMappingVoucher"
        class="msg-buttons flex-row revert-button"
      >
        <button class="msg-btn btn primary" @click="$close(this, true)">
          {{ $t('i18nComponent.MessageBox.Yes') }}
        </button>
        <button class="msg-btn btn secondary-outline" @click="$close(this, false)">
          {{ $t('i18nComponent.MessageBox.No') }}
        </button>
        <div class="flex flex-al-center">
          <div
            class="txt-view-detail"
            @click="
              () => {
                eventCustomClick($close, this);
              }
            "
          >
            {{ $t('i18nComponent.MessageBox.ViewDetail') }}
          </div>
        </div>
      </div>
      <!-- Lưu và lưu thành mẫu mới pdtai 14.05.2024 -->
      <div
        v-else-if="type == $ms.constant.MessageBoxType.confirm_Save_SaveNew_Cancel"
        class="msg-buttons flex-row revert-button"
      >
        <button class="msg-btn btn primary btn-custom-width" @click="$close(this, 'Save')">
          {{ $t('i18nComponent.MessageBox.Save') }}
        </button>
        <button class="msg-btn btn primary-outline" @click="$close(this, 'SaveNew')">
          {{ $t('i18nComponent.MessageBox.SaveNew') }}
        </button>
        <div class="flex" />
        <button class="msg-btn btn secondary-outline" @click="$close(this, 'No')">
          {{ $t('i18nComponent.MessageBox.No') }}
        </button>
      </div>
      <div v-else-if="type == $ms.constant.MessageBoxType.confirm_view_bctc" class="msg-buttons flex-row revert-button">
        <button class="msg-btn btn primary btn-custom-width" @click="$close(this, 'ViewBctc')">Xem báo cáo</button>
        <button class="msg-btn btn secondary-outline" @click="$close(this, 'No')">
          {{ $t('i18nComponent.MessageBox.No') }}
        </button>
        <div class="flex" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/scss/components/MsMessageBox.scss';
.revert-button {
  flex-direction: row-reverse;
}
.ic-question-view-bctc {
  top: 19px;
  right: 50px;
}
</style>
